(function () {
var $d08adf8e73f0213b$exports = {};
var $d08adf8e73f0213b$var$header = document.querySelector(".header");
window.addEventListener("scroll", function() {
    if (window.scrollY > 40) $d08adf8e73f0213b$var$header.classList.add("scrolled");
    else $d08adf8e73f0213b$var$header.classList.remove("scrolled");
});
var $d08adf8e73f0213b$var$experienceItems = document.querySelectorAll(".works__item");
$d08adf8e73f0213b$var$experienceItems.forEach(function(item) {
    var button = item.querySelector(".works__button");
    button.addEventListener("click", function() {
        var isActive = item.classList.contains("active");
        $d08adf8e73f0213b$var$experienceItems.forEach(function(el) {
            el.classList.remove("active");
        });
        if (!isActive) item.classList.add("active");
    });
});
var $d08adf8e73f0213b$var$footer = document.querySelector(".footer");
// Только устройства с сенсорным экраном (iPhone, Android, iPad)
var $d08adf8e73f0213b$var$isTouchDevice = window.matchMedia("(pointer: coarse)").matches;
if ($d08adf8e73f0213b$var$footer && $d08adf8e73f0213b$var$isTouchDevice) {
    var $d08adf8e73f0213b$var$updateBackground = function updateBackground() {
        var rect = $d08adf8e73f0213b$var$footer.getBoundingClientRect();
        // Если верх футера находится в пределах экрана,
        // делаем фон body черным.
        var isFooterVisible = rect.top < window.innerHeight;
        document.body.classList.toggle("footer-visible", isFooterVisible);
    };
    window.addEventListener("scroll", $d08adf8e73f0213b$var$updateBackground, {
        passive: true
    });
    window.addEventListener("resize", $d08adf8e73f0213b$var$updateBackground);
    $d08adf8e73f0213b$var$updateBackground();
}

})();
//# sourceMappingURL=frontend.bb9e672d.js.map
